import { render, staticRenderFns } from "./AccountVerificationRouterView.vue?vue&type=template&id=267fdf34&"
import script from "./AccountVerificationRouterView.vue?vue&type=script&lang=js&"
export * from "./AccountVerificationRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports